import type { MarkerColor, MarkerKind, RoomView } from '@concept/protocol';
import { markerInventoryLimit } from '@concept/game-core/marker-rules';

export const MARKER_COLORS: readonly MarkerColor[] = [
  'green',
  'blue',
  'red',
  'yellow',
  'black',
];

export function remainingMarkerCount(
  board: RoomView['board'],
  color: MarkerColor,
  kind: MarkerKind,
): number {
  const limit = markerInventoryLimit(color, kind);
  if (limit === null) return Number.POSITIVE_INFINITY;
  return limit - board.filter(
    (marker) => marker.color === color && marker.kind === kind,
  ).length;
}

export function availableMarkerColor(
  board: RoomView['board'],
  preferredColor: MarkerColor,
  kind: MarkerKind,
): MarkerColor | undefined {
  if (remainingMarkerCount(board, preferredColor, kind) > 0) return preferredColor;
  return MARKER_COLORS.find((color) => remainingMarkerCount(board, color, kind) > 0);
}

export function orderedConceptColors(
  room: Pick<RoomView, 'board' | 'conceptOrder'>,
): MarkerColor[] {
  const activeColors = MARKER_COLORS.filter((color) =>
    room.board.some((marker) => marker.color === color),
  );
  const ordered = room.conceptOrder.filter((color) => activeColors.includes(color));
  return [...ordered, ...activeColors.filter((color) => !ordered.includes(color))];
}

export function orderedCubeMarkerIds(
  room: Pick<RoomView, 'board' | 'cubeOrder'>,
  color: MarkerColor,
): string[] {
  const activeIds = room.board
    .filter((marker) => marker.color === color && marker.kind === 'cube')
    .sort((left, right) => left.order - right.order)
    .map((marker) => marker.id);
  const ordered = room.cubeOrder.filter((markerId) => activeIds.includes(markerId));
  return [...ordered, ...activeIds.filter((markerId) => !ordered.includes(markerId))];
}
